// extracted by mini-css-extract-plugin
module.exports = {"pintxo-coachmark":"Coachmark_pintxo-coachmark__FJ6tW"};